import { required } from 'vee-validate/dist/rules'
import { extend, ValidationProvider, ValidationObserver, setInteractionMode } from "vee-validate"
setInteractionMode("eager")
extend("required", {
    ...required,
    message: "{_field_} no puede estar vacio",
});

import { mapGetters } from 'vuex';

const information = {
    components: { ValidationObserver, ValidationProvider },
    data: () => ({
        ruleMaxCaracters: [
            v => !!v || 'Este campo es obligatorio',
            v => v.length <= 250 || 'Max 250 caracteres'
        ],
        info: {
            title: '',
            description: '',
            file: null,
            pais: null,
            centro: null,
            segmento: null,
            campana: null
        },
        informacion: [],
        loading: false,
        loadingInfo: false,
        dialog: false,
        headersBox : [
            { text: "Titulo", value: "title", align: 'start', sortable: false },
            { text: "Descripcion", value: "description", align: 'start', sortable: false },
            { text: "Acciones", value: "actions", align: 'start', sortable: false },
        ],
    }),
    mounted() {
        this.fecthInformation();
    },
    computed: {
         ...mapGetters(['getPaises', 'getCentros', 'getSegmentos', 'getCampanas']),
        Rol() {
            return this.$store.state.rol;
        },
        filteredCentros() {
            return this.getCentros.filter(centro => centro.inPaisId === this.info.pais).sort((a, b) => a.vc_Descripcion.localeCompare(b.vc_Descripcion));
        },
        filteredSegmentos() {
            let segmentos = []
            let uniqueSegmento = []

            if (Array.isArray(this.info.centro) && this.info.centro.length > 0) {
                segmentos = this.getCampanas.filter(item => this.info.centro.includes(item.in_CentroId)).map(item => item.in_SegmentoId);
                uniqueSegmento = [...new Set(segmentos)];
            }
            return this.getSegmentos.filter(item => uniqueSegmento.includes(item.Id)).sort((a, b) => a.vc_Descripcion.localeCompare(b.vc_Descripcion));
        },
        filteredCampanas() {
            let campanas = [];

            if (Array.isArray(this.info.segmento) && this.info.segmento.length > 0) {
                campanas = this.getCampanas.
                    filter(item => this.info.centro.includes(item.in_CentroId)).
                    filter(item => this.info.segmento.includes(item.in_SegmentoId));
            }
            return campanas.sort((a, b) => a.vc_Descripcion.localeCompare(b.vc_Descripcion));
        },
    },
    methods: {
        cancel() {
            this.info = {
                title: '',
                description: '',
                file: null
            }
            this.$refs.datos.reset();
            this.dialog = false;
        },
        verMas(enlace) {
            window.location.href = enlace;
        },
        async submitInformation(reset) {

            if(this.info.description.length > 250){
                this.$toast.error('El maximo de caracteres en el campo descripcion es 250');
                this.loading = false;
                return false
            }

            this.loading = true;
            const payload = {
                userId: this.$store.state.id,
                title: this.info.title,
                description: this.info.description,
                file: this.info.file,
                pais: this.info.pais,
                centro: this.info.centro,
                segmento: this.info.segmento,
                campana: this.info.campana
            };
            try {
                const formData = new FormData();
                formData.append('userId', payload.userId);
                formData.append('title', payload.title);
                formData.append('description', payload.description);
                formData.append('file', payload.file);
                formData.append('pais', payload.pais);
                formData.append('centro', payload.centro);
                formData.append('segmento', payload.segmento);
                formData.append('campana', payload.campana);

                const response = await this.$axios.post('information', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                reset(); // Resetea el formulario después de enviar los datos
                this.cancel();
                this.$toast.success('Informacion guardado con exito');

            } catch (error) {
                this.$toast.error('Hubo un problema en guardar la informacion')
            } finally {
                this.fecthInformation();
                this.loading = false;
            }
        },
        async fecthInformation() {
            this.loadingInfo = true;
            try {
                const response = await this.$axios.get('/information/' + this.$store.state.id);
                this.informacion = response.data.information;
            } catch (error) {
                this.$toast.error('Problemas en obtener los datos');
            } finally {
                this.loadingInfo = false;
            }
        },
        verDocumento(filePath) {
            window.open(filePath, '_blank');
        },
        async openForm() {
            this.dialog = true;
            // this.watchEnabled = false;
            // try {
            //     await Promise.all([
            //         this.fetchDocId(),
            //         /*this.fetchCountry(),
            //         this.fetchCenter(),
            //         this.fetchCampaign(),
            //         //this.fetchSegment()*/
            //     ]);
            // } catch (error) {
            //     console.error('Error al cargar los datos del formulario:', error);
            // }
        },
    }
}
export default information